import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { api } from "@api/api";
import FeedbackInline from "@componentes/feedback/FeedbackInline";
import { ajustarTamanhoFonteAnalista } from "../../../../estilos/global";

export default function DialogRecusaCadastro({
  open,
  tipo,
  cadastroId,
  onClose,
  onRecusado,
}) {
  const [motivo, setMotivo] = useState("");
  const [erro, setErro] = useState("");
  const [enviando, setEnviando] = useState(false);

  useEffect(() => {
    if (open) {
      setMotivo("");
      setErro("");
    }
  }, [open]);

  const confirmar = async () => {
    if (enviando) return;

    const texto = motivo.trim();

    if (!texto) {
      setErro("Informe o motivo da recusa.");
      return;
    }

    setEnviando(true);
    setErro("");

    try {
      const response = await fetch(api.reject(tipo, cadastroId), {
        method: "DELETE",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ motivo: texto }),
      });

      if (!response.ok) {
        const dados = await response.json().catch(() => ({}));
        throw new Error(
          dados.message || "Não foi possível recusar o cadastro.",
        );
      }

      onRecusado();
    } catch (error) {
      setErro(
        error instanceof Error ? error.message : "Erro ao recusar cadastro.",
      );
    } finally {
      setEnviando(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        if (!enviando) onClose();
      }}
      disableEscapeKeyDown={enviando}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle sx={{ fontSize: ajustarTamanhoFonteAnalista("1rem") }}>
        Recusar cadastro
      </DialogTitle>

      <DialogContent>
        <Typography
          sx={{
            mb: 2,
            fontSize: ajustarTamanhoFonteAnalista("0.9rem"),
          }}
        >
          O cadastro será excluído. Informe o motivo da recusa.
        </Typography>

        <FeedbackInline mensagem={erro} />

        <TextField
          autoFocus
          fullWidth
          multiline
          minRows={4}
          label="Motivo da recusa"
          value={motivo}
          onChange={(event) => setMotivo(event.target.value)}
          disabled={enviando}
          required
          sx={{ mt: 1 }}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={enviando}>
          Cancelar
        </Button>

        <Button
          color="error"
          variant="contained"
          onClick={confirmar}
          disabled={enviando || !motivo.trim()}
        >
          {enviando ? "Recusando…" : "Confirmar recusa"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
